import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const assignBulkUserToGroups = async (updatedGroups) => {
  try {
    const response = await apiClient.put(`/users/bulkAssignUserGroups`, updatedGroups);

    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
